export default {
    callable: (element: HTMLElement) => {
        const link = element as HTMLAnchorElement;
        link.onclick = (event) => {
            if (window.parent) {
                window.parent.location.href = link.href;
                event.preventDefault();
            }
        };
    },
};
